/**
 * enginePreProcessJson_Merge_ArrayBlock.ts - Array block entry processing for EnginePreProcessJson
 * Port of C# EnginePreProcessJson_Merge_ArrayBlock.cs
 * Pure ES module - works in both Node.js and browser via bundler
 */
import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';

import { GenerateHtmlJson } from '../../base/loader/generateHtmlJson.js';
import {
    mergeArrayBlock
} from './enginePreProcessJson_Array.js';
import type { EnginePreProcessJson } from './enginePreProcessJson.js';
import type { ILoaderPreProcessJson } from './enginePreProcessJson.js';
import type { TemplateInfoNode, TemplateOperation } from './enginePreProcessJson_Helper.js';
import type { PreProcessJsonMergeContext } from './enginePreProcessJson_Merge.js';

/**
 * Merge template function signature
 */
type MergeTemplateFn = (
    engine: EnginePreProcessJson,
    loader: ILoaderPreProcessJson,
    context: PreProcessJsonMergeContext,
    templateInfo: TemplateInfoNode,
    htmlJson: JsonObject,
    dataJson: JsonObject,
    operations: TemplateOperation[],
    genOperations: boolean,
    componentHtml: JsonObject | null,
    recursionDepth: number,
    flowStack: string[] | null
) => string;

/**
 * Process array block entry - determines if this is boolean conditional or array iteration
 * Port of C# ProcessArrayBlockEntry method
 */
export function processArrayBlockEntry(
    mergeTemplate: MergeTemplateFn,
    engine: EnginePreProcessJson,
    loader: ILoaderPreProcessJson,
    context: PreProcessJsonMergeContext,
    key: string,
    arrayBlockData: JsonObject,
    templateInfo: TemplateInfoNode,
    dataJson: JsonObject,
    operations: TemplateOperation[],
    genOperations: boolean,
    componentHtml: JsonObject | null,
    recursionDepth: number,
    flowStack: string[] | null
): string {
    // Array iteration block - {{@Key}} is now arrays only (conditionals use {{?Key}})

    // Extract key from the key (new format: a6_Items -> Items)
    const blockKey = GenerateHtmlJson.getKeyName(key);

    // Delegate to mergeArrayBlock
    return mergeArrayBlock(
        mergeTemplate,
        engine,
        loader,
        context,
        arrayBlockData,
        blockKey,
        dataJson,
        templateInfo,
        operations,
        genOperations,
        componentHtml,
        recursionDepth,
        flowStack
    );
}
